import { render, staticRenderFns } from "./ShowError.vue?vue&type=template&id=1bb704e4&"
import script from "./ShowError.vue?vue&type=script&lang=js&"
export * from "./ShowError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports